module.exports = __webpack_public_path__ + "img/media-intro-bg.55cc3daa.jpg";